import React from 'react';
import { Typography } from '@material-ui/core';
import { SingleValueProps } from 'react-select/src/components/SingleValue';
import { OptionTypeBase } from 'react-select/src/types';

export const SingleValue = (props: SingleValueProps<OptionTypeBase>) => (
  <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
    {props.children}
  </Typography>
);
